import { api } from '@/lib/api';
import type {
  CalibratorsListResponse,
  CalibratorsFilters,
  Calibrator,
  CreateCalibratorInput,
} from './types';

// =============================================================================
// API Functions
// =============================================================================

/**
 * Get calibrators with filtering, pagination, and sorting.
 */
export async function getCalibrators(
  filters: CalibratorsFilters = {},
): Promise<CalibratorsListResponse> {
  return api.get<CalibratorsListResponse>('/v4/calibrators', {
    search: filters.search || undefined,
    enabled: filters.enabled,
    pageNumber: filters.page ?? 0,
    pageLength: filters.pageLength ?? 25,
    sortKey: filters.sortKey,
    sortDirection: filters.sortDirection,
  });
}

/**
 * Get a single calibrator by ID
 */
export async function getCalibrator(id: string): Promise<Calibrator> {
  return api.get<Calibrator>(`/v4/calibrators/${id}`);
}

/**
 * Create a new calibrator (via V3 MongoDB API)
 */
export async function createCalibrator(
  data: CreateCalibratorInput,
): Promise<{ calibrator: { _id: string } }> {
  return api.post('/v4/calibrators/', data);
}

/**
 * Update an existing calibrator (via V3 MongoDB API)
 */
export async function updateCalibrator(
  id: string,
  data: Partial<CreateCalibratorInput>,
): Promise<unknown> {
  return api.put(`/v4/calibrators/${id}`, data);
}

/**
 * Delete a calibrator (via V3 MongoDB API)
 */
export async function deleteCalibrator(id: string): Promise<unknown> {
  return api.delete(`/v4/calibrators/${id}`);
}
